// @flow

import React from 'react'
import moment from 'moment'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

export type PropTypes = {
  name: string,
  profile: string,
  ownerPath: string,
  ownerProfileImage: string,
  isTopHost: boolean,
  createdAt: Date,
}

export default (props: Object) => (
  <section className="space-main__section-big space-main__hostarea">
    <h2 className="space-main__headline-big">
      {i18n.t('page.room.ownerTitle')}
    </h2>

    <div className="space-main__host">
      <div className="mod-host__icon-inner">
        <a href={props.ownerPath}>
          <img
            src={imageURLWithTransform(props.ownerProfileImage, {
              width: 500,
              height: 500,
              crop: 'fill',
            })}
            alt={props.name}
            className="is-hover space-main__host-icon"
          />
        </a>
        {props.isTopHost ? (
          <img
            src={imagePath('common/gold_superhost.png')}
            alt={i18n.t('page.room.tophost')}
            className="space-main__owner-superhost"
          />
        ) : null}
      </div>

      <div className="space-main__host-info">
        {props.isTopHost ? (
          <p className="host-ribon mod-evaluate__help">
            {i18n.t('page.room.tophost')}
            <i className="fa fa-question-circle mod-evaluate__question" />
            <span className="mod-tooltip mod-host__superhost__help-tooltip">
              <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                <span className="baloon-inner">
                  {i18n.t('page.room.captionTophost')}
                </span>
              </span>
            </span>
          </p>
        ) : null}
        <div className="space-main__host-namearea">
          <h3
            className="space-main__host-name link__subcolor mr10"
            itemProp="legalName"
          >
            <a href={props.ownerPath}>{props.name}</a>
          </h3>
          <p className="space-main__host-date">
            {i18n.t('page.room.registeredDate')}
            <span className="space-main__host-date-days">
              {moment(props.createdAt).format(
                i18n.t('page.shared.dateFormat1'),
              )}
            </span>
          </p>
        </div>
        <p className="space-main__host-text">{props.profile}</p>
        <p className="space-main__host-more">
          <a href={props.ownerPath}>{i18n.t('page.room.moreOwnerInfo')}</a>
        </p>
      </div>
    </div>

    <div className="space-main__authentication">
      <img
        src={imagePath('www/common/confirm.svg')}
        alt={i18n.t('page.room.certMark')}
        className="space-main__authentication-icon"
      />
      <p className="space-main__authentication-headline">
        {i18n.t('page.room.certificated')}
      </p>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailOwnerSection/index.jsx